// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/credentials.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.Challenge
 */
export var Challenge;
(function (Challenge) {
    /**
     * @generated from enum value: UNKNOWN_CHALLENGE = 0;
     */
    Challenge[Challenge["UNKNOWN_CHALLENGE"] = 0] = "UNKNOWN_CHALLENGE";
    /**
     * @generated from enum value: PASSWORD = 1;
     */
    Challenge[Challenge["PASSWORD"] = 1] = "PASSWORD";
    /**
     * otp password is only sent after password credentials have been successfully validated
     *
     * @generated from enum value: SMS_OTP = 2;
     */
    Challenge[Challenge["SMS_OTP"] = 2] = "SMS_OTP";
    /**
     * @generated from enum value: TOTP = 3;
     */
    Challenge[Challenge["TOTP"] = 3] = "TOTP";
    /**
     * @generated from enum value: EMAIL_OTP = 4;
     */
    Challenge[Challenge["EMAIL_OTP"] = 4] = "EMAIL_OTP";
})(Challenge || (Challenge = {}));
// Retrieve enum metadata with: proto3.getEnumType(Challenge)
proto3.util.setEnumType(Challenge, "no.jotta.openapi.Challenge", [
    { no: 0, name: "UNKNOWN_CHALLENGE" },
    { no: 1, name: "PASSWORD" },
    { no: 2, name: "SMS_OTP" },
    { no: 3, name: "TOTP" },
    { no: 4, name: "EMAIL_OTP" },
]);
/**
 * @generated from message no.jotta.openapi.Credentials
 */
export class Credentials extends Message {
    /**
     * @generated from field: string password = 1;
     */
    password = "";
    /**
     * unused backup/recovery codes are also accepted
     *
     * @generated from field: string totp_code = 2;
     */
    totpCode = "";
    /**
     * @generated from field: string sms_code = 3;
     */
    smsCode = "";
    /**
     * @generated from field: string email_code = 4;
     */
    emailCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.Credentials";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "totp_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sms_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "email_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Credentials().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Credentials().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Credentials().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Credentials, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.Challenges
 */
export class Challenges extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.Challenge challenges = 1;
     */
    challenges = [];
    /**
     * @generated from field: repeated no.jotta.openapi.Challenge accepted_challenges = 2;
     */
    acceptedChallenges = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.Challenges";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "enum", T: proto3.getEnumType(Challenge), repeated: true },
        { no: 2, name: "accepted_challenges", kind: "enum", T: proto3.getEnumType(Challenge), repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new Challenges().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Challenges().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Challenges().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Challenges, a, b);
    }
}
